import {
  getStandardDeviation,
  rateOfChange,
} from '@mais-retorno-front/libs/util-helpers';
import { IAssetQuotes } from '../interfaces';
import { IChartSeries } from '@mais-retorno-front/models/chart-serie';

export const createComparisonVolatilitySerie = (
  assetQuotes: IAssetQuotes[] | undefined
): IChartSeries[] => {
  if (!assetQuotes) return;

  const periods = 21;
  let devPad = null;

  const serie = assetQuotes.map((assetQuote) => {
    const _quotes = assetQuote.quotes.map(({ c }) => ({ quote: c }));
    const quotesLength = assetQuote.quotes.length;
    const serieChart = [];

    for (let i = periods; i < quotesLength; i++) {
      const quotesPerPeriod = _quotes.slice(i - periods, i + 1);

      devPad = rateOfChange(quotesPerPeriod);
      devPad = getStandardDeviation(devPad) * Math.sqrt(252);

      if (!isNaN(devPad)) serieChart.push([assetQuote.quotes[i].d, devPad]);
    }

    return {
      data: serieChart,
      name: assetQuote.nicename,
      id: assetQuote.id,
      color: assetQuote.color,
      type: 'line',
    };
  });

  return serie;
};
